import React, {
  useState,
  useMemo,
  useRef,
  useCallback,
  useEffect,
} from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
// import "ag-grid-community/styles/ag-theme-alpine.css";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import moment from "moment";
import Pagination from "../../Common/Pagination/Pagination";
import { CSSTransition } from "react-transition-group";
import {minDate} from "../../Constants/Constants"
import _ from "lodash";
const YardDetails = () => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [rmvBtn, setRmvBtn] = useState(false);
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const formRef = useRef(null);
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [selectedRowsData, setselectedRowsData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [showSearch, setShowSearch] = useState(false);
  const totalPages = Math.ceil(totalRecords / pageSize);
  const startItem = (currentPage - 1) * pageSize + 1;
  const endItem = Math?.min(startItem + rowData?.length - 1, totalRecords);
  const [company, setCompany] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [loadingOverlayVisible, setLoadingOverlayVisible] = useState(false);
  const [yard, setYard] = useState([]);
  const [product, setProduct] = useState([]);
  const [productId, setProductId] = useState("");
  const [yardId, setYardId] = useState("");
  const [companyId, setCompanyId] = useState("");

  const [filterCriteria, setfilterCriteria] = useState({
    company_id: selectedCompanyId ? selectedCompanyId : "",
    product_name_id: productId,
    p_incoming_date: "",
  });
  const urlSearchString = window.location.search;
  const params = new URLSearchParams(urlSearchString);
  const [urlCompanyId, setURLCompanyId] = useState(
    parseInt(params.get("companyId")) || null
  );
  const onPageChange = (newPage) => {
    setCurrentPage(newPage);
    gridRef.current.api.showLoadingOverlay();
  };
  const onPageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value));
    gridRef.current.api.showLoadingOverlay();
    setCurrentPage(1); // Reset to the first page when page size changes
  };
  const handleRefreshClick = () => {
    gridRef.current.api.showLoadingOverlay();
    getData();
    setfilterCriteria({
      company_id: "",
      product_name_id: "",
      yard_id: "",
      p_incoming_date: "",
    });
    setSelectedCompanyId("");
    setProductId("");
    setYardId("");
    updateURLParams("companyId", null);
    setURLCompanyId(null);
    // setCompanyId("")
    setURLCompanyId("")
  };
  const nonEmptyFilterCriteria = Object.fromEntries(
    Object.entries(filterCriteria).filter(
      ([key, value]) => value !== null && value !== undefined && value !== ""
    )
  );
  const options = {
    whereFilters: nonEmptyFilterCriteria,
    skip: currentPage,
    take: pageSize,
  };
  const getData = async () => {
    let BASE_URL = SERVER_URL + `/api/yard-details/all-yard-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(options),
    });
    const result = await res.json();
    if (res.ok) {
      setTotalRecords(result.total);
      setRowData(result.data);
      // Check if gridRef is defined and has the api property before using it
      if (gridRef.current && gridRef.current.api) {
        gridRef.current.api.hideOverlay();
      }
    } else {
      setRowData([]);
    }
  };

  let check = true;
  useEffect(() => {
    if (check) {
      // Show the loading overlay here when either diamondId or supplierId changes
      if (loadingOverlayVisible) {
        gridRef.current.api.showLoadingOverlay();
      }
      setLoadingOverlayVisible(true);
      const fecthDebounced = _.debounce(getData, 500);
      fecthDebounced();
      return () => {
        fecthDebounced.cancel();
      };
    }
    check = false;
  }, [currentPage, pageSize, filterCriteria, urlCompanyId]);

  useEffect(() => {
    setCurrentPage(1);
  }, [filterCriteria]);
  const [colDefs, setColDefs] = useState([
    {
      headerName: "S. No",
      valueGetter: (params) => {
        const currentPageContext = params.context.currentPage;
        const pageSizeContext = params.context.pageSize;
        return (
          (currentPageContext - 1) * pageSizeContext + params.node.rowIndex + 1
        );
      },
      width: 100,
      minWidth: 100,
      // headerCheckboxSelection: true,
      // checkboxSelection: true,
    },
    {
      headerName: "Yard Name",
      field: "companyYard.yard_name",
      editable: false,
      width: 120,
      minWidth: 120,
    },
    {
      headerName: "Product Name",
      field: "productDetails.productName.size",
      editable: false,
      width: 150,
      minWidth: 150,
    },
    {
      headerName: "Company Name",
      field: "company.company_name",
      valueFormatter: (params) => {
        const location = params?.data?.company?.location;
        // const type = params.data.company.type;
        return `${params.value}, ${location}`;
      },
      editable: false,
      minWidth: 205,
    },
    {
      headerName: "Incoming Quantity",
      field: "quantity",
      valueFormatter: (params) => {
        const val = params.value ? params.value : "-";
        return `${val}`;
      },
      editable: false,
      minWidth: 150,
    },
    {
      headerName: "Incoming Date",
      field: "p_incoming_date",
      valueFormatter: (params) => {
        const val = params.value ? params.value : "-";
        return `${val}`;
      },
      editable: false,
      minWidth: 150,
    },
    {
      headerName: "Dispatch Date",
      field: "p_dispatch_date",
      valueFormatter: (params) => {
        const val = params.value ? params.value : "-";
        return `${val}`;
      },
      editable: false,
      width: 150,
      minWidth: 150,
    },
    {
      headerName: "Opening Stock",
      field: "p_opening_stock",
      editable: false,
      width: 145,
      minWidth: 145,
    },
    {
      headerName: "Dispatch",
      field: "p_consumed_stock",
      editable: false,
      width: 110,
      minWidth: 110,
    },
    {
      headerName: "Closing Stock",
      field: "p_closing_stock",
      editable: false,
      width: 140,
      minWidth: 140,
    },
    {
      headerName: "Goods Return/Over Stock",
      field: "p_over_stock",
      editable: false,
      width: 180,
      minWidth: 220,
    },
    {
      headerName: "Shortage Stock",
      field: "p_shortage_stock",
      editable: false,
      width: 150,
      minWidth: 150,
    },
    {
      headerName: "Damage Stock",
      field: "p_damage_stock",
      editable: false,
      width: 150,
      minWidth: 150,
    },
    // {
    //   headerName: "Actions",
    //   cellRenderer: (params) => (
    //     <>
    //       <button
    //         className="btn btn-outline-danger btn-sm"
    //         onClick={() => deleteRow(params.data.id)}
    //       >
    //         <i className="mdi mdi-delete" />
    //       </button>{" "}
    //       <button
    //         className="btn btn-outline-secondary btn-sm"
    //         onClick={() => addDataToModal(params.data)}
    //         data-toggle="modal"
    //         data-target="#editModal"
    //       >
    //         <i className="mdi mdi-note-edit-outline" />
    //       </button>
    //     </>
    //   ),
    //   minWidth: 205,
    // },
  ]);

  const onCellValueChanged = (params) => {
    const updatedData = params.data;
    updateCellData(updatedData);
  };

  const updateCellData = async (updatedData) => {
    // console.log("updatedData", updatedData);
    let BASE_URL = SERVER_URL + `/api/yard-details/yard-details/${user_id}`;
    const {
      id,
      yard_id,
      p_over_stock,
      p_shortage_stock,
      p_damage_stock,
      company_id,
      product_name_id,
    } = updatedData;
    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        yard_id,
        p_over_stock,
        p_shortage_stock, 
        p_damage_stock,
        company_id,
        product_name_id,
      }),
    });
    const data = await res.json();
    if (res.ok) {
      getData();
      toast.success(data.message);
      gridRef.current.api.hideOverlay();
    } else {
      getData();
      toast.error(data.message);
    }
  };

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    if(res.ok){
      setCompany(result.data);
    }else{
      setCompany([])
    }
  };

  useEffect(() => {
    getCompany();
  }, []);
  const updateURLParams = (key, value) => {
    const params = new URLSearchParams(window.location.search);
    if (value) {
      params.set(key, value);
    } else {
      params.delete(key);
    }
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.pushState({}, "", newUrl);
  };

  function handleCompanyChange(e) {
    const companyId = e.target.value ? parseInt(e.target.value) : "";
    getYardDetails(companyId);
  }

  const getYardDetails = async (companyId) => {
    // Exit early if companyId is empty
    if (!companyId) {
      setYard([]);
      setYardId("");
      setProduct([]);
      setProductId("");
      setfilterCriteria({ product_name_id: "" });
      setURLCompanyId(null);
      updateURLParams("companyId", null);
      setSelectedCompanyId(companyId);
      setfilterCriteria((prevFilterCriteria) => ({
        ...prevFilterCriteria,
        company_id: companyId,
      }));
      return;
    }
    setURLCompanyId(companyId);
    updateURLParams("companyId", companyId);
    setSelectedCompanyId(companyId);
    setfilterCriteria((prevFilterCriteria) => ({
      ...prevFilterCriteria,
      company_id: companyId,
      yard_id: "",
      product_name_id: "",
      p_incoming_date: "",
    }));

    const BASE_URL = `${SERVER_URL}/api/com-yard/single-company-yards/${user_id}/${companyId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if(res.ok){
      setYard(result.data);
    }else{
      setYard([]);
    }

    const BASEURL = `${SERVER_URL}/api/product/drop-products/${user_id}`;
    const response = await fetch(BASEURL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        company_id: companyId,
      }),
    });
    const product_result = await response.json();
    if(response.ok){
      setProduct(product_result.data);
    }else{
      setProduct([]);
    };
  };

  const handleProductChange = (e) => {
    const productId = e.target.value != "" ? parseInt(e.target.value) : "";
    // Update filterCriteria with the selected company's ID
    setProductId(productId);
    setfilterCriteria((prevFilterCriteria) => ({
      ...prevFilterCriteria,
      product_name_id: productId,
    }));
  };

  const handleYardChange = (e) => {
    const yardId = e.target.value != "" ? parseInt(e.target.value) : "";
    // Update filterCriteria with the selected company's ID
    setYardId(yardId);
    setfilterCriteria((prevFilterCriteria) => ({
      ...prevFilterCriteria,
      yard_id: yardId,
    }));
  };

  const handleFilterChange = (name, value) => {
    setfilterCriteria(() => {
      return {
        ...filterCriteria,
        [name]: value,
      };
    });
  };

  useEffect(() => {
    setCompanyId(urlCompanyId);
    if (!isNaN(urlCompanyId)) {
      getYardDetails(urlCompanyId);
    }
  }, []);

  useEffect(() => {
    setfilterCriteria((prevFilterCriteria) => ({
      ...prevFilterCriteria,
      company_id: urlCompanyId ? urlCompanyId : selectedCompanyId,
    }));
  }, []);
  const sortingOrder = useMemo(() => {
    return ["desc", "asc", null];
  }, []);
  const defaultColDef = useMemo(() => ({
    filter: true,
    flex: 1,
    headerPosition: "sticky",
  }));
  const onBtnExport = useCallback(() => {
    gridRef.current.api.exportDataAsCsv();
  }, []);
  const onGridReady = useCallback((params) => {
    params.api.showLoadingOverlay();
  });
  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="card-title">
            Yard Details Table &nbsp;
            <span>
              <button
                className="btn btn-sm btn-light btn-icon-text border"
                onClick={handleRefreshClick}
              >
                Refresh{" "}
                <i
                  className="mdi mdi-refresh"
                  style={{ height: "4px", width: "4px" }}
                ></i>{" "}
              </button>
            </span>
          </div>
          <div className="table_btn">
            <div className="mb-3"></div>

            <div
              style={{
                marginBottom: "20px",
              }}
            >
              <button
                onClick={() => onBtnExport()}
                className="btn btn-outline-excel mr-1 "
              >
                <span className="mr-1">
                  <i className="mdi mdi-file-export"></i>
                </span>
                Export to Excel
              </button>
            </div>
          </div>
          <div className="search mb-3">
            <div className="row">
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor="company_id">Select Company</label>
                  <select
                    className="form-control form-control-lg"
                    onChange={handleCompanyChange}
                    value={companyId ? selectedCompanyId : urlCompanyId}
                    id="company_id"
                  >
                    <option value="">Select Company (All)</option>
                    {company &&
                      company?.length > 0 &&
                      company?.map((item, id) => {
                        return (
                          <React.Fragment key={id}>
                            <option
                              value={item.id}
                              key={id}
                            >{`${item.company_name}, ${item.location}`}</option>
                          </React.Fragment>
                        );
                      })}
                  </select>
                </div>
              </div>
              {selectedCompanyId && (
                <div className="col-md-2">
                  <div className="form-group">
                    <label htmlFor="yard_id">Select Yard</label>
                    <select
                      className="form-control form-control-lg"
                      onChange={handleYardChange}
                      value={yardId}
                      id="yard_id"
                    >
                      <option value="">Select yard (All)</option>
                      {yard &&
                        yard?.length > 0 &&
                        yard?.map((item, id) => {
                          return (
                            <option
                              value={item.id}
                              key={id}
                            >{`${item.yard_name}`}</option>
                          );
                        })}
                    </select>
                  </div>
                </div>
              )}
              {selectedCompanyId && (
                <div className="col-md-2">
                  <div className="form-group">
                    <label htmlFor="product_id">Select Product</label>
                    <select
                      className="form-control form-control-lg"
                      onChange={handleProductChange}
                      value={productId}
                      id="product_id"
                    >
                      <option value="">Select Product (All)</option>
                      {product &&
                        product?.length > 0 &&
                        product?.map((item, id) => {
                          return (
                            <option
                              value={item.id}
                              key={id}
                            >{`${item.size}`}</option>
                          );
                        })}
                    </select>
                  </div>
                </div>
              )}
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor="incoming_date">Select Incoming Date</label>
                  <input
                    type="date"
                    className="form-control form-control-lg"
                    placeholder="Search by Date"
                    max={new Date().toISOString().split("T")[0]}
                    onChange={(e) =>
                      handleFilterChange("p_incoming_date", e.target.value)
                    }
                    value={filterCriteria.p_incoming_date}
                    id="incoming_date"
                    min={minDate}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor="dispatch_date">Select Dispatch Date</label>
                  <input
                    type="date"
                    className="form-control form-control-lg"
                    placeholder="Search by Date"
                    max={new Date().toISOString().split("T")[0]}
                    onChange={(e) =>
                      handleFilterChange("p_dispatch_date", e.target.value)
                    }
                    value={filterCriteria.p_dispatch_date}
                    id="dispatch_date"
                    min={minDate}
                  />
                </div>
              </div>
              {/* <div className="col-md-3" style={{ display: "flex" }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by party name"
                  onChange={(e) =>
                    handleFilterChange("party_name", e.target.value)
                  }
                />
              </div> */}
            </div>
          </div>
          <div>
            <div
              className="ag-theme-quartz"
              style={{ width: "100%", height: 550 }}
            >
              <AgGridReact
                ref={gridRef}
                rowData={rowData}
                columnDefs={colDefs}
                defaultColDef={defaultColDef}
                context={{ currentPage, pageSize }}
                headerHeight={40}
                rowHeight={50}
                sortingOrder={sortingOrder}
                enableCellTextSelection={true}
                rowSelection={"multiple"}
                suppressRowClickSelection={true}
                suppressCellSelection={true}
                onGridReady={onGridReady}
                overlayLoadingTemplate={
                  '<span className="ag-overlay-loading-center">Please wait while your records are loading...</span>'
                }
                onCellValueChanged={onCellValueChanged}
              />
            </div>
          </div>
        </div>
        <Pagination
          currentPage={currentPage}
          totalRecords={totalRecords}
          pageSize={pageSize}
          totalPages={totalPages}
          startItem={startItem}
          endItem={endItem}
          onPageChange={onPageChange}
          onPageSizeChange={onPageSizeChange}
        />
      </div>
    </>
  );
};

export default YardDetails;
